<template>
  <v-app id="inspire">
    <v-navigation-drawer
      :mini-variant.sync="miniVariant"
      v-model="drawer"
      enable-resize-watcher
      app
      ref="customMenu"
    >
      <v-list >
        <div v-for="(link, i) in menu" :key="i">
          <v-list-tile
            v-if="link.type === 'link'"
            @click="go(link.component)"
            :class="link.component === $route.name ? 'highlighted' : ''"
          >
          <!-- v-role="{ rights: link.rights, user: $store.state.auth.roles }" -->
            <v-list-tile-action>
              <v-icon>{{ link.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <!-- <v-list-tile-title>{{ $t(link.lang) }}</v-list-tile-title> -->
              <v-list-tile-title>
                {{ link.title }}
                <v-chip v-if="link.count >= 0" class="navigation-title-chip ml-1" label text-color="blue">
                  {{ getCounter(link.component) }}
                </v-chip>
                <v-chip v-if="link.additional" class="navigation-title-chip" label text-color="white" color="orange">
                  {{ link.additional }}
                </v-chip>
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="link.type === 'divider'"></v-divider>
          <v-subheader
            v-if="link.type === 'header'"
            :key="link.header"
          >
            {{ link.title }}
          </v-subheader>
        </div>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar color="primary" dark fixed app :clipped-left="clipped">
      <v-toolbar-side-icon @click.stop="toggleMenu"></v-toolbar-side-icon>
      <img
        src="@/assets/img/logo/logo-beta.png"
        class="logo ml-4"
      >
      <!-- <v-toolbar-title>{{ titleApp }}</v-toolbar-title> -->

      <v-text-field class="searchWidth"
            :class="{ ml_150: moveSearch }"
           label="Search"
           append-icon="search"
           single-line
           hide-details
           light
           solo
           height="30"
           color="#000"
           background-color="#fff"
         ></v-text-field>
         <v-spacer></v-spacer>
      <!-- {{ $store.state.lang.locale }}
      <v-menu bottom left>
        <v-btn
          slot="activator"
          dark
          icon
        >
          <v-icon>language</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile
            v-for="(item, i) in languages"
            :key="i"
            @click="changeLang(item)"
          >
            <v-list-tile-title>{{ $t(item) }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu> -->
      <v-menu
        v-model="userMenu"
        :close-on-content-click="false"
        offset-y
        :right="true"
      >
        <v-btn
          icon
          fab
          slot="activator"
          class="mr-0"
        >
          <i class="material-icons">
            account_circle
          </i>
        </v-btn>

        <v-card class="customMenu">
          <v-list>
            <v-list-tile avatar>
              <v-list-tile-avatar>
                <i class="material-icons green--text">
                  account_circle
                </i>
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title>{{this.$store.state.user.fullname}}</v-list-tile-title>
                <v-list-tile-sub-title>{{this.$store.state.user.email}}</v-list-tile-sub-title>
              </v-list-tile-content>

            </v-list-tile>
          </v-list>

          <v-divider></v-divider>

          <v-list-tile avatar>
            <v-list-tile-avatar>
              <i class="material-icons light-blue--text">
                account_balance_wallet
              </i>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>Koins: {{this.$store.state.user.credits}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn flat @click="logout()" class="orange--text">
              <v-icon>exit_to_app</v-icon>
              Logout
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-menu>
      <v-menu
        :close-on-content-click="false"
        :nudge-left="70"
        offset-x
        offset-y
      >
      <v-btn icon fab slot="activator" class="ml-0">
        <v-icon>notifications</v-icon>
      </v-btn>
        <v-card>
          <v-list class="customNotification">
            <!-- <v-list-tile>
              <v-list-tile-action>
                <v-icon color="teal darken-2">email</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>New messages</v-list-tile-title>
            </v-list-tile>
            <v-divider></v-divider>
            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="teal darken-2">present_to_all</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>hints</v-list-tile-title>
            </v-list-tile>
            <v-divider></v-divider> -->

            <v-list-tile>
              <v-list-tile-action>
                <v-icon color="teal darken-2">done</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>No notifications</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-menu>
      <v-btn icon fab slot="activator">
        <v-icon>notifications</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-footer :fixed="fixed" app>
      <span>&copy; {{ year }} - Kol-Yom Admin
      </span>
    </v-footer>
  </v-app>
</template>

<script>
export default {
  name: 'ToolbarComponent',
  data () {
    return {
      clipped: true,
      fixed: false,
      drawer: true,
      miniVariant: false,
      year: (new Date()).getFullYear(),
      titleApp: '',
      languages: [],
      sum: 150,
      userMenu: false,
      message: false,
      hints: true,
      moveSearch: true,
      menu: [
        {
          type: 'header',
          title: 'Main Navigation:'
        },
        {
          type: 'link',
          icon: 'dashboard',
          title: 'Dashboard',
          // lang: 'main_menu.crm',
          component: 'Dashboard',
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'timeline',
          title: 'Site Insights',
          component: 'SiteInsights',
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'icon-bar-chart',
          title: 'Weather',
          // lang: 'main_menu.crm',
          component: 'Weather',
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'folder_open',
          title: 'All Projects',
          // lang: 'main_menu.crm',
          component: 'Projects',
          count: true,
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'icon-link',
          title: 'All Links',
          count: true,
          // lang: 'main_menu.crm',
          component: 'Links',
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'icon-docs',
          title: 'All Reports',
          additional: 'Beta',
          count: true,
          // lang: 'main_menu.crm',
          component: 'Reports',
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'group',
          title: 'Users',
          count: true,
          // lang: 'main_menu.crm',
          component: 'Users',
          rights: ['admin']
        },
        {
          type: 'link',
          icon: 'language',
          title: 'Proxies',
          count: true,
          // lang: 'main_menu.crm',
          component: 'Proxies',
          rights: ['admin']
        }
        // {
        //   type: 'link',
        //   icon: 'icon-rocket',
        //   title: 'Scrapers',
        //   additional: 'Beta',
        //   // lang: 'main_menu.crm',
        //   component: 'Scrapers',
        //   rights: ['manager', 'admin', 'guest', 'client']
        // }
      ],
      topMenu: [
        {
          text: 'Кошелек',
          link: 'balance'
        },
        {
          text: 'Профиль',
          link: 'profile'
        },
        {
          text: 'Выйти',
          link: 'logout'
        }
      ]
    }
  },
  props: {
    source: String
  },
  computed: {
    Projects () {
      return this.$store.state.metadata.totalProjects
    },
    Links () {
      return this.$store.state.metadata.totalLinks
    },
    Reports () {
      return this.$store.state.user.reports_count
    },
    Proxies () {
      return this.$store.state.metadata.totalProxies
    },
    Users () {
      return this.$store.state.metadata.totalUsers
    }
  },
  mounted () {
    // this.languages = this.$store.state.lang.languages
    this.titleApp = this.$store.state.settings.appName
  },
  methods: {
    getCounter (componentName) {
      return this[componentName]
    },
    go (dest) {
      this.$router.push({name: dest})
    },
    logout () {
      this.$store.dispatch('LOGOUT')
    },
    changeLang (val) {
      let params = { lang: val }
      this.$router.push({name: this.$router.name, params: params})
    },
    toggleMenu () {
      let menuEl = this.$refs.customMenu
      if (!menuEl.isMobile) {
        this.miniVariant = !this.miniVariant
      } else {
        this.drawer = !this.drawer
      }
      this.moveSearch = !this.moveSearch
    }
  }
}
</script>

<style>

</style>

<style src="./style.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/components/toolbar/ToolbarComponent.vue